import { useCallback } from 'react';
import { CoverageLine } from 'enums';
import { useSearchTeamInsuranceProduct } from 'hooks';

export function useGetApiProductsByCoverageLines() {
  const { refetch: fetchTeamProducts } = useSearchTeamInsuranceProduct({
    enabled: false,
  });

  const getApiProductsByCoverageLines = useCallback(
    async (coverageLines: CoverageLine[]) => {
      const { data } = await fetchTeamProducts();
      const products = data?.items || [];

      return products
        .filter((product) =>
          coverageLines.some((submissionCoverageLine) =>
            product.insuranceProduct.coverageLines.some(
              (insuranceProductCoverageLine) => insuranceProductCoverageLine.coverageLine === submissionCoverageLine,
            ),
          ),
        )
        .filter((product) => !!product.insuranceProduct.externalProductId);
    },
    [fetchTeamProducts],
  );

  return {
    getApiProductsByCoverageLines,
  };
}
